﻿import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ConnectionCustomFieldSummary from "./ConnectionCustomFieldSummary";
import ConnectionCustomFieldManager from "./ConnectionCustomFieldManager";

import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepTab";

const ConnectionCustomFieldHome = () => {
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

    // heap.io

    switch (newValue) {
      case 0:
        window.heap.track("Connection Custom Field - Summary Tab");
        break;
      case 1:
        window.heap.track("Maintenance - Manager Tab");
        break;
    }
  };

  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "40px",
          width: "100%",
          backgroundColor: "var(--default-light)",
        }}
      >
        <ShepTabs
          variant="tertiary"
          value={tabValue}
          onChange={handleTabChange}
          aria-label="workflow tabs"
        >
          <ShepTab
            variant="tertiary"
            key="1"
            label={"Fields"}
            iconPosition="start"
          />
          <ShepTab
            variant="tertiary"
            key="2"
            label={"Values"}
            iconPosition="start"
          />
        </ShepTabs>
      </div>
      <Box sx={{ maxHeight: "100%" }}>
        {tabValue === 0 && <ConnectionCustomFieldSummary />}
        {tabValue === 1 && <ConnectionCustomFieldManager />}
      </Box>
    </Container>
  );
};
export default ConnectionCustomFieldHome;
